<!-- Filtro e Botão para Incluir Orçamento -->
<div class="po-row">
  <po-input class="po-md-5" name="buscarcamento" p-label="Filtrar orçamento" [(ngModel)]="bOrcamento"
    (p-change-model)="buscaOrcamento()" p-icon="po-icon po-icon-search">
  </po-input>

  <po-button style="margin-left: auto" class="po-m-5" p-label="+ Incluir orçamento" (p-click)="onClick()"
    p-type="primary" [p-disabled]="inclusaodesativada">
  </po-button>
</div>

<!-- Tabela de Orçamentos -->
<po-table p-sort="true" p-container="shadow" [p-columns]="columns" [p-items]="orcamentoList" [p-loading]="loading"
  p-container="shadow" p-hide-text-overflow="true" p-height="550" p-striped="true">
</po-table>

<!-- Modals -->
<po-modal p-title="Efetivar orçamento" [p-primary-action]="confirm" [p-secondary-action]="close">
  <div class="po-row">
    Confirma o envio do orçamento para análise e continuidade do processo de
    compra pela área comercial?
  </div>
</po-modal>

<po-modal #pagamento p-title="Comprovante de pagamento" [p-primary-action]="comprovanteModalClose" p-hide-close="true">
  <po-upload #upload name="upload" p-label="Enviar comprovante para o setor financeiro" [p-restrictions]="restrictions"
    p-required p-url="{{API}}comprovante" (p-upload)="changeEvent($event)">
  </po-upload>
</po-modal>

<po-modal #OrdemColeta p-title="Ordem de coleta" [p-primary-action]="confirmOrdemColeta"
  [p-secondary-action]="closeOrdemColeta">
  <form #formOrdemColeta="ngForm">
    <div class="po-row po-font-subtitle">Dados para transporte (Coleta)</div>
    <po-input name="emailColeta" p-label="Enviar Para:" p-icon="po-icon po-icon-mail" [(ngModel)]="emailColeta"
      p-required="true"></po-input>
    <po-input name="emailCopiaColeta" p-label="Cópia:" p-icon="po-icon po-icon-document-double"
      [(ngModel)]="emailCopiaColeta" p-required="false"></po-input>
    <po-datepicker name="dataColeta" p-label="Data" [(ngModel)]="ocData" p-required="true">
    </po-datepicker>
    <po-input name="pedido" p-label="Pedido" [(ngModel)]="pedidoOc" p-required="true"
      *ngIf="this.informaPedido"></po-input>
    <po-input name="transportadora" p-label="Transportadora" p-icon="po-icon po-icon-truck" [(ngModel)]="ocTransp"
      p-required="true"></po-input>
    <po-input name="endereco" p-label="Endereço entrega" p-icon="po-icon po-icon-pin" [(ngModel)]="ocEndereco"
      p-required="true"></po-input>
    <po-input name="nomeMotorista" p-label="Nome do motorista" p-icon="po-icon po-icon-security-guard"
      [(ngModel)]="ocMotorista" p-required="true"></po-input>
    <po-input name="rg" p-label="RG" p-icon="po-icon po-icon-credit-payment" [(ngModel)]="ocRg"
      p-required="true"></po-input>
    <po-input name="tpVeiculo" p-label="Tipo de veículo" p-icon="po-icon po-icon-steering-wheel" [(ngModel)]="ocTpVeic"
      p-required="true"></po-input>
    <po-input name="placa" p-label="Placa" p-icon="po-icon po-icon-truck" [(ngModel)]="ocPlaca"
      p-required="true"></po-input>
    <po-number name="capacidade" p-label="Capacidade" [(ngModel)]="ocCapacidade" p-required="true"></po-number>
    <po-textarea name="obs" [(ngModel)]="obsOc" p-label="Observações" p-required="false" p-rows="4">
    </po-textarea>
  </form>
</po-modal>

<po-modal #ModalEstoque p-title="Atenção" [p-primary-action]="confirmEstoque">
  <div class="po-row po-font-text-large-bold">
    Os itens abaixo não possuem saldo suficiente e serão tratados pela equipe
    Comercial.
  </div>
  <div class="po-row">
    <po-table [p-items]="this.estoqueMessage"> </po-table>
  </div>
</po-modal>

<po-modal #ModalXMLDanfe p-title="2o Via XML & DANFE" [p-primary-action]="confirmXMLDANFE"
  [p-secondary-action]="closeXMLDANFE">
  <div>
    <po-input name="emaildanfe" p-label="E-mail" p-icon="po-icon po-icon-mail" [(ngModel)]="emaildanfe"
      p-required="true"></po-input>
  </div>
</po-modal>

<po-modal #ModalBoleto p-title="2o Via Boleto" [p-primary-action]="confirmBoleto" [p-secondary-action]="closeBoleto">
  <div>
    <po-input name="emailboleto" p-label="E-mail" p-icon="po-icon po-icon-mail" [(ngModel)]="emailBoleto"
      p-required="true"></po-input>
  </div>
</po-modal>

<po-modal #ModalPrint [p-primary-action]="print" [p-secondary-action]="closePrint" p-size="auto" p-hide-close="true">
  <po-container>
    <po-container> </po-container>
    <po-container> </po-container>
  </po-container>
</po-modal>

<po-modal #ModalChassi p-title="Lista de Chassis" [p-secondary-action]="closeModalChassi" p-size="auto" class="po-md-6">
  <po-table [p-items]="this.chassiList" [p-columns]="this.chassiColumns"> </po-table>
</po-modal>

<po-modal #pagOnline p-title="Pagamentos" p-hide-close="true" [p-primary-action]="CloseModalpagOnline" p-size="sm">
  <div class="po-row">
    <po-decimal class="po-md-6 po-lg-4" name="subTotal" [(ngModel)]="subTotal" p-label="TOTAL" p-readonly="true">
    </po-decimal>
    <po-decimal style="margin-left: auto" class="po-md-6 po-lg-4" name="Saldo" [(ngModel)]="saldo" p-label="SALDO"
      p-readonly="true">
    </po-decimal>
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <div class="po-row">
    <po-button class="po-md-3 po-lg-5" style="margin: auto" p-label="PAGAR" (p-click)="OptPagamentos()"
      p-type="primary">
    </po-button>
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <po-table [p-items]="this.tiposPag" [p-columns]="this.tiposColumns">
  </po-table>
</po-modal>

<po-modal #infoOptPag [p-primary-action]="closeinfoOptPag" p-size="sm" p-hide-close="true">
  <div class="po-row">
    <po-button style="margin: auto;" class="po-md-3 po-lg-6" p-label="PIX" p-type="primary" (p-click)="openpagPix()"
      *ngIf="this.cppix.indexOf(this.CondpgSelect) != -1">
    </po-button>
    <po-divider class="po-row" p-label=""> </po-divider>
    <po-button style="margin: auto;" class="po-md-3 po-lg-6" p-label="CARTÃO" p-type="primary"
      (p-click)="openpagCartao()" *ngIf="this.cpcred.indexOf(this.CondpgSelect) != -1">
    </po-button>
    <po-divider class="po-row" p-label=""> </po-divider>
  </div>
</po-modal>

<po-modal #informa p-size="sm" p-hide-close="true" [p-primary-action]="closeModalInforma">
  <div class="po-row">
    <po-textarea class="po-md-8" name="observacao" [(ngModel)]="obs" p-maxlength="250" p-label="Observações">
    </po-textarea>
    <po-decimal style="margin: auto;" class="po-md-3 po-lg-4" [(ngModel)]="vlrpag" p-label="Informe o valor a pagar"
      p-type="primary">
    </po-decimal>
    <po-button style="margin-right: auto;" class="po-md-3 po-lg-3" p-label="Anexar" (p-click)="openComprovante(1)"
      p-type="primary">
    </po-button>
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <div class="po-row">
  </div>
</po-modal>

<po-modal #pagCartao p-click-out="false" p-hide-close="true" p-size="100" p-title="Formulário de Pagamento"
  [p-primary-action]="closePagCartao">
  <form #formPagamento="ngForm">
    <po-container class="po-m-10">
      <div p-icon="po-icon po-icon-user">
        <h2>Informações Gerais</h2>
      </div>
      <hr />
      <po-input id="nome" class="po-md-6" p-clean="true" name="nome" [(ngModel)]="nome" p-required p-label="Nome">
      </po-input>
      <po-input id="sobrenome" class="po-md-6" p-clean="true" name="sobrenome" [(ngModel)]="sobrenome" p-required
        p-label="Sobrenome"> </po-input>
      <po-input id="doc" class="po-md-6" p-clean="true" name="document" [(ngModel)]="document" p-mask-format-model
        p-required p-label="CPF / CNPJ" [p-minlength]="minLength">
      </po-input>
      <po-input id="mail" class="po-md-6" p-clean="true" name="mail" p-required p-label="E-mail" [(ngModel)]="mail">
      </po-input>
      <div class="po-row">
        <po-input id="tele1" style="margin: auto;" class="po-m-6" p-clean="true" [p-minlength]="minLengthTel"
          name="telent1" p-required p-label="Telefone" [(ngModel)]="telent1">
        </po-input>
      </div>
      <po-input id="endereco" class="po-md-6" p-clean="true" name="enderecoente" p-mask-format-model
        [p-minlength]="minLength" p-required p-label="Endereço" [(ngModel)]="endereco">
      </po-input>
      <po-input id="cep" class="po-md-6" p-clean="true" p-required name="cepente" [(ngModel)]="cep" p-mask-format-model
        p-label="CEP" [p-minlength]="minLengthCEP">
      </po-input>
      <po-input id="num" class="po-md-6" p-clean="true" p-required name="numero" p-label="Número" [(ngModel)]="numero">
      </po-input>
      <po-input id="estado" class="po-md-6" p-clean="true" p-required name="estado" p-label="Estado"
        [(ngModel)]="estado">
      </po-input>
      <po-input id="cidade" class="po-md-6" p-clean="true" p-required name="cidade" p-label="Cidade"
        [(ngModel)]="cidade">
      </po-input>
      <po-input id="bairro" class="po-md-6" p-clean="true" p-required name="bairro" p-label="Bairro"
        [(ngModel)]="bairro">
      </po-input>
      <hr />
      <po-divider class="po-row" p-label=""> </po-divider>
      <div p-icon="po-icon po-icon-user">
        <h2>Info. de Pagamento</h2>
      </div>
      <hr />
      <po-decimal class="po-md-6" name="valorasalvar" [(ngModel)]="valorasalvar" p-placeholder="Informe o valor aqui" p-label="Valor a Pagar" p-required>
      </po-decimal>
      <po-divider class="po-row" p-label=""> </po-divider>
      <div class="po-row">
        <po-button class="po-md-6" style="margin: auto;" p-label="CONTINUAR" p-type="primary" (p-click)="pagar()"
          [p-disabled]="formPagamento.invalid || lockBntContinua">
        </po-button>
      </div>
    </po-container>
  </form>
</po-modal>

<po-modal #getnetModal [p-primary-action]="closeGetNet" (p-close)="closeGetNet.action()">
  <div class="po-row">
    <div class="po-row" style="color:red;">
      <h1 style="color:red; margin:auto;">Atenção:</h1>
      <h3 style="color:red; margin:auto;">O processo a seguir é realizado através de comunicação com segurança garantida
        pela Getnet.</h3>
    </div>
    <po-divider class="po-row" p-label=""> </po-divider>
    <div class="po-row">
      <img src="../../../assets/logo_getnet.png" style="margin: auto;" />
    </div>
    <po-divider class="po-row" p-label=""> </po-divider>
    <div class="po-row">
      <h3 style="margin:auto;">Para efetuar o pagamento, clicar no botão abaixo:</h3>
    </div>
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <div class="po-row">
    <po-button style="margin: auto;" class="pay-button-getnet" (p-click)="Travar()" p-label="REALIZAR PAGAMENTO" p-type="primary" [p-disabled]="lockButton">
    </po-button>
  </div>
</po-modal>

<po-modal #pagPix p-title="Pagamento PIX" [p-primary-action]="closepagPix">
  <form #formPix="ngForm">
    <div class="po-row">
      <po-decimal style="margin: auto;" class="po-md-6 po-lg-4" name="vlrpix" [(ngModel)]="vlrpix"
        p-label="Valor a Pagar" p-required>
      </po-decimal>
      <po-divider class="po-row" p-label=""> </po-divider>
      <po-button style="margin: auto;" class="pay-button-getnet" p-label="Confirmar" p-type="primary"
        (p-click)="openQRCode()" [p-disabled]="formPix.invalid">
      </po-button>
    </div>
  </form>
</po-modal>

<po-modal #qrCode [p-primary-action]="closeQRCODE" p-size="sm" p-title="PAGAMENTO PIX" p-hide-close="true">
  <div class="po-row">
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <div>
    <div #StatusPix class="po-font-subtitle po-text-center" style="color: rgb(83, 83, 83); font-size: 130%;">Faça a
      leitura do QR Code e confirme depois de pagar.</div>
    <po-widget class="po-m-10">
      <div id="print" class="po-text-center">
        <!-- <ngx-qrcode style="margin: auto;" [elementType]="elementType" [value]="value" errorCorrectionLevel="L">
        </ngx-qrcode> -->

        <qrcode [qrdata]="value" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
      </div>
      <div class="po-text-center" style="font-size: 130%">VALOR: R$ {{this.vlrpix}}</div>
    </po-widget>
  </div>
  <po-divider class="po-row" p-label=""> </po-divider>
  <div class="po-row">
    <po-button style="margin: auto;" class="po-md-4" p-icon="po-icon po-icon-copy" p-label="Copiar" p-type="primary"
      (p-click)="copyQRCode(this.value)">
    </po-button>
    <po-button style="margin: auto;" class="po-md-4" p-label="Gerar" p-type="primary" p-icon="po-icon po-icon-qr-code"
      (p-click)="geraQRCode()">
    </po-button>
    <po-button style="margin: auto;" class="po-md-4" p-label="Imprimir" p-type="primary" p-icon="po-icon po-icon-print"
      (p-click)="printPage()">
    </po-button>
  </div>
</po-modal>

<po-modal #pagcomp p-title="Comprovante de pagamento" [p-primary-action]="compModalClose" p-hide-close="true">
  <po-upload #uploadOn name="upload" p-label="Enviar comprovante para o setor financeiro"
    [p-restrictions]="restrictions" p-required p-url="{{API}}comprovante" (p-upload)="uploadSaldo($event)">
  </po-upload>
</po-modal>

<po-modal #noPIX [p-primary-action]="closePIX" [p-secondary-action]="verificaStatusPix" p-title="PAGAMENTO PIX">
  <div class="po-row">
    <img src="../../../assets/no.png" style="height: 15%; width: 15%; margin:auto;" />
    <po-divider class="po-row" p-label=""> </po-divider>
    <div #StatusPix class="po-font-subtitle po-text-center"
      style="color: rgb(83, 83, 83); font-size: 130%; margin:auto;">O pagamento não foi processado ou encontrado. Favor
      tentar novamente em alguns segundos.</div>
  </div>
</po-modal>

<po-modal #okPIX [p-primary-action]="closePIX" p-title="PAGAMENTO PIX">
  <div class="po-row">
    <img src="../../../assets/ok.png" style="height: 15%; width: 15%; margin:auto;" />
    <po-divider class="po-row" p-label=""> </po-divider>
    <div #StatusPix class="po-font-subtitle po-text-center"
      style="color: rgb(83, 83, 83); font-size: 130%; margin:auto;">O pagamento foi realizado com sucesso! Para
      continuar, clique em fechar.</div>
  </div>
</po-modal>

<po-loading-overlay p-screen-lock="true" [hidden]="isHideLoading" p-text="Carregando...">
</po-loading-overlay>
